import React, { useEffect } from 'react';
import { Divider, Grid, Theme, Checkbox } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { COLOR_LIGHT_GRAY, COLOR_WHITE } from '../../const/Const';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor } from '../../GlobalState';
import { TInfoData } from '../../types/ExtInfoBox';
import { useFormContext, Controller } from 'react-hook-form';
import { AppCheckbox } from '../parts/input/AppCheckbox';

type TProps = {
  data: TInfoData;
  boxNo: number;
  index: number;
  register: any;
  setValue: any;
  errors: any;
};

export const Info: React.FC<TProps> = (props: TProps) => {
  const { data, boxNo, index, register, setValue, errors } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });
  const [checked, setChecked] = React.useState(true);

  const handleChange = (e: any) => {
    setValue(
      `infoData.${boxNo}.list.${index}.check`,
      e.target.checked ? true : false
    );
    setChecked(e.target.checked ? true : false);
  };

  useEffect(() => {
    setValue(
      `infoData.${boxNo}.list.${index}.check`,
      data.check == 1 ? true : false
    );
    setChecked(data.check == 1 ? true : false);
  }, []);

  return (
    <>
      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>
            <Checkbox
              {...register(`infoData.${boxNo}.list.${index}.check`)}
              checked={checked}
              onClick={handleChange}
              style={{
                color: 'white'
              }}
            />

            {data.item}
          </div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainer}>
            <input
              type='hidden'
              {...register(`infoData.${boxNo}.list.${index}.item`)}
              defaultValue={data.item}
            />
            <input
              {...register(`infoData.${boxNo}.list.${index}.data`)}
              defaultValue={data.data}
              className={classes.input}
            />
          </div>
        </div>
      </div>

      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
    </>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    subContainer: {
      marginLeft: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    textMainContainer: {
      display: 'flex',
      backgroundColor: props => props.mainColor,
      width: '40%',
      minHeight: 60,
      alignItems: 'center'
    },
    textContainer: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 60,
      alignItems: 'center',
      width: '60%'
    },
    inputContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%'
    },
    input: {
      minHeight: 40,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    }
  })
);
